import { buildUrl, configure, addHeader, removeHeader } from "./client";
import {
    requestGet,
    requestPut,
    requestPatch,
    requestPost,
    requestDelete,
} from "./api";

const httpClient = {
    configure: configure,
    url: buildUrl,
    headers: {
        add: addHeader,
        remove: removeHeader,
    },
    api: {
        get: requestGet,
        put: requestPut,
        patch: requestPatch,
        post: requestPost,
        delete: requestDelete,
    },
};

export default httpClient;
